import { BaseFetch } from "../main-model";
export default class ProjectModel extends BaseFetch {

    getProjectBy = (data) =>
    this.authFetch({
      url: "project/getProjectBy",
      method: "POST",
      body: data,
    });
    getProjectById = (data) =>
    this.authFetch({
      url: "project/getProjectById",
      method: "POST",
      body: data,
    });
    insertProject = (data) =>
    this.authFetch({
      url: "project/insertProject",
      method: "POST",
      body: data,
    });
    updateProjectById = (data) =>
    this.authFetch({
      url: "project/updateProjectById",
      method: "POST",
      body: data,
    });
    deleteProjectById = (data) =>
    this.authFetch({
      url: "project/deleteProjectById",
      method: "POST",
      body: data,
    });
}
